export default {
  inserted (el, binding) {
    el.scroll = () => {
      const rect = el.getBoundingClientRect()
      // X 可视
      const inX = () => {
        if (rect.left >= 0 && rect.left <= window.innerWidth) {
          return true
        } else if (rect.left < 0 && rect.width + rect.left >= 0) {
          return true
        }
      }
      // Y 可视
      const inY = () => {
        if (rect.top >= 0 && rect.top <= window.innerHeight) {
          return true
        } else if (rect.top < 0 && rect.height + rect.top >= 0) {
          return true
        }
      }
      if (inX() && inY()) {
        window.removeEventListener('scroll', el.scroll)
        delete el.scroll
        const { value } = binding
        // if value is function
        if (typeof value === 'function') {
          value()
        // if value is object
        } else if (typeof value === 'object') {
          const { fn, delay, ...args } = value
          setTimeout(() => {
            fn(args)
          }, delay || 0)
        }
      }
    }
    window.addEventListener('scroll', el.scroll)
    el.scroll()
  }
}
